import React from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import "./App.css";
import "./screens/Dashboard/Dashboard.css";
import Sidebar from "./Components/Sidebar/Sidebar";
import DashboardPanel from "./screens/Dashboard/DashboardPanel/DashboardPanel";
import Employees from "./screens/Dashboard/Employees/Employees";
import EmployeeAdd from "./screens/EmployeeAdd/EmployeeAdd";
import EmployeeDetails from "./screens/EmployeeDetails/EmployeeDetails";
import AboutUs from "./screens/Dashboard/AboutUs/AboutUs";
import AboutUsAE from "./screens/AboutUsAE/AboutUsAE";
import Login from "./screens/Login/Login";
import Clients from "./screens/Dashboard/Clients/Clients";
import AddEditClients from "./screens/AddEditClients/AddEditClients";
import Authors from "./screens/Dashboard/Authors/Authors";
import AuthorsAddEdit from "./screens/AuthorsAddEdit/AuthorsAddEdit";
import NewsEventCatageory from "./screens/Dashboard/NewsEventCatageory/NewsEventCatageory";
import NECatAddEdit from "./screens/NECatAddEdit/NECatAddEdit";
import NewsAndEvents from "./screens/Dashboard/News&Events/News&Events";
import NewsAndEventsAddEdit from "./screens/News&EventsAddEdit/News&EventsAddEdit";
import Publications from "./screens/Dashboard/Publications/Publications";
import PublicationsAE from "./screens/PublicationsAddEdit/PublicationsAddEdit";
import ContactUsers from "./screens/Dashboard/ContactUsers/ContactUsers";
import RecentNewsNotification from "./screens/Dashboard/RecentNewsNotification/RecentNewsNotification";
import RecentNewsNotiAddEdit from "./screens/RecentNewsNotiAddEdit/RecentNewsNotiAddEdit";
import HomeScreen from "./screens/Dashboard/HomeScreen/HomeScreen";
import HomeScreenAddEdit from "./screens/HomeScreenAddEdit/HomeScreenAddEdit";
import Services from "./screens/Dashboard/Services/Services";
import ServicesAddEdit from "./screens/ServicesAddEdit/ServicesAddEdit";
import Solutions from "./screens/Dashboard/Solutions/Solutions";
import SolutionsAddEdit from "./screens/SolutionsAddEdit/SolutionsAddEdit";
import Team from "./screens/Dashboard/Team/Team";
import TeamAddEdit from "./screens/TeamAddEdit/TeamAddEdit";

function App() {
  const Dashboard = () => {
    return (
      <div className="dashboard-layout">
        <Sidebar />
        <div className="dashboard-content">
          <Outlet />
        </div>
      </div>
    );
  };
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />}>
            <Route path="" element={<DashboardPanel />} />
            <Route path="/dashboard/dashPanel" element={<DashboardPanel />} />

            <Route path="/dashboard/home" element={<HomeScreen />} />
            <Route path="/dashboard/home/add" element={<HomeScreenAddEdit />} />
            <Route path="/dashboard/home/edit" element={<HomeScreenAddEdit isEdit />} />

            <Route path="/dashboard/about" element={<AboutUs />} />
            <Route path="/dashboard/about/add" element={<AboutUsAE />} />
            <Route path="/dashboard/about/edit" element={<AboutUsAE isEdit />} />

            <Route path="/dashboard/team" element={<Team />} />
            <Route path="/dashboard/team/add" element={<TeamAddEdit />} />
            <Route path="/dashboard/team/edit" element={<TeamAddEdit isEdit />} />

            <Route path="/dashboard/services" element={<Services />} />
            <Route path="/dashboard/services/add" element={<ServicesAddEdit />} />
            <Route path="/dashboard/services/edit" element={<ServicesAddEdit isEdit />} />

            <Route path="/dashboard/solutions" element={<Solutions />} />
            <Route path="/dashboard/solutions/add" element={<SolutionsAddEdit />} />
            <Route path="/dashboard/solutions/edit" element={<SolutionsAddEdit isEdit />} />

            <Route path="/dashboard/employees" element={<Employees />} />
            <Route
              path="/dashboard/employees/empDetails"
              element={<EmployeeDetails />}
            />
            <Route
              path="/dashboard/employees/empAdd"
              element={<EmployeeAdd />}
            />
            <Route
              path="/dashboard/employees/empEdit"
              element={<EmployeeAdd isEdit />}
            />
            <Route path="/dashboard/clients" element={<Clients />} />
            <Route
              path="/dashboard/clients/AddClient"
              element={<AddEditClients />}
            />
            <Route
              path="/dashboard/clients/editClient"
              element={<AddEditClients isEdit />}
            />
            <Route
              path="/dashboard/clients/deleteClient"
              element={<AddEditClients isDelete />}
            />

            <Route path="/dashboard/authors" element={<Authors />} />
            <Route path="/dashboard/authors/add" element={<AuthorsAddEdit />} />
            <Route
              path="/dashboard/authors/edit"
              element={<AuthorsAddEdit isEdit />}
            />
            <Route
              path="/dashboard/authors/delete"
              element={<AuthorsAddEdit isDelete />}
            />
            <Route
              path="/dashboard/newsEventCatageory"
              element={<NewsEventCatageory />}
            />
            <Route
              path="/dashboard/newsEventCatageory/add"
              element={<NECatAddEdit />}
            />
            <Route
              path="/dashboard/newsEventCatageory/edit"
              element={<NECatAddEdit isEdit />}
            />
            <Route
              path="/dashboard/newsEventCatageory/delete"
              element={<NECatAddEdit isDelete />}
            />

            <Route path="/dashboard/recentNews" element={<RecentNewsNotification />} />
            <Route path="/dashboard/recentNews/add" element={<RecentNewsNotiAddEdit />} />
            <Route path="/dashboard/recentNews/edit" element={<RecentNewsNotiAddEdit isEdit />} />


            <Route path="/dashboard/news&Events" element={<NewsAndEvents />} />
            <Route
              path="/dashboard/news&Events/add"
              element={<NewsAndEventsAddEdit />}
            />
            <Route
              path="/dashboard/news&Events/edit"
              element={<NewsAndEventsAddEdit isEdit />}
            />
            <Route
              path="/dashboard/news&Events/delete"
              element={<NewsAndEventsAddEdit isDelete />}
            />

            <Route path="/dashboard/publications" element={<Publications />} />
            <Route
              path="/dashboard/publications/add"
              element={<PublicationsAE />}
            />
            <Route
              path="/dashboard/publications/edit"
              element={<PublicationsAE isEdit />}
            />
            <Route
              path="/dashboard/publications/delete"
              element={<PublicationsAE isDelete />}
            />
            <Route path="/dashboard/contactUsers" element={<ContactUsers />} />


          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
